module.exports = "/assets/images/thankyou-badge.svg";